
import axios from 'axios'
import { REACT_APP_API } from 'cfgCommon/config';
import { orderPossibleActions } from '../BFFUtils';

export async function getStateMachine(statusId, isCarmuv = false) {
  const result = await axios.get(`${REACT_APP_API}/possible-actions?status_id=${statusId}&is_carmuv=${isCarmuv}`)

  const { possible_action } = result?.data

  return { ...result?.data, possible_action: orderPossibleActions(possible_action, statusId) }
}
